export const getLocation = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
